export const FlowerLogo = ({ size = 32, online = true, className = "" }) => {
  const petal = online ? "#3FB950" : "#F85149";
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} data-testid="kicq-logo" aria-hidden="true">
      {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
        <ellipse
          key={i}
          cx="50"
          cy="22"
          rx="13"
          ry="20"
          fill={i === 0 ? "#DA3633" : petal}
          transform={`rotate(${i * 45} 50 50)`}
        />
      ))}
      <circle cx="50" cy="50" r="13" fill="#D29922" />
    </svg>
  );
};
